import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexModule } from '@angular/flex-layout';
import { MatNotificationsComponent } from './mat-notifications.component';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatNotificationService, MatNotificationRef } from './mat-notifications.service';
import { MatButtonModule } from '@angular/material/button';
import { MatNotificationComponent } from './mat-notification.component';
import { SharedModule } from 'src/lib/shared.module';

@NgModule({
	declarations: [
		MatNotificationsComponent,
		MatNotificationComponent
	],
	imports: [
		CommonModule,
		FlexModule,
		MatCardModule,
		MatIconModule,
		MatProgressBarModule,
		MatButtonModule,
		SharedModule
	],
	exports: [
		MatNotificationComponent
	]
})
export class MatNotificationsModule { }

export {MatNotificationService as MatNotification, MatNotificationRef, MatNotificationsComponent};